/* tslint:disable */
/* eslint-disable */
/**
 * Probonio full API Docs
 * If you stumbled upon this page and want to integrate Probonio into your business software [click here!](/api/external)    If you\'re looking for more information about Probonio [head over here](https://probonio.de)    **This documentation describes all Endpoints of the Probonio API. It\'s created for experienced Probonio Developers only!**   <a href=\"http://localhost:4100/mock-idp/realms/probonio/protocol/openid-connect/logout\" target=\"_blank\"><button>     <h4>Click here to trigger a full logout from Keycloak.</h4> </button></a><br /> 
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface BaseEmployeeDTO
 */
export interface BaseEmployeeDTO {
    /**
     * 
     * @type {string}
     * @memberof BaseEmployeeDTO
     */
    'salutation'?: BaseEmployeeDTOSalutationEnum;
    /**
     * 
     * @type {string}
     * @memberof BaseEmployeeDTO
     */
    'status': BaseEmployeeDTOStatusEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof BaseEmployeeDTO
     */
    'roles': Array<BaseEmployeeDTORolesEnum>;
    /**
     * 
     * @type {string}
     * @memberof BaseEmployeeDTO
     */
    'employeeType'?: BaseEmployeeDTOEmployeeTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof BaseEmployeeDTO
     */
    'source': BaseEmployeeDTOSourceEnum;
    /**
     * 
     * @type {string}
     * @memberof BaseEmployeeDTO
     */
    'civilStatus'?: BaseEmployeeDTOCivilStatusEnum;
    /**
     * The country of the user\'s home address in ISO31661Alpha2 format
     * @type {string}
     * @memberof BaseEmployeeDTO
     */
    'homeAddressCountry'?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseEmployeeDTO
     */
    'legalTermsAction'?: BaseEmployeeDTOLegalTermsActionEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof BaseEmployeeDTO
     */
    'requiredActions': Array<BaseEmployeeDTORequiredActionsEnum>;
    /**
     * 
     * @type {string}
     * @memberof BaseEmployeeDTO
     */
    'preferredPortal': BaseEmployeeDTOPreferredPortalEnum;
    /**
     * 
     * @type {string}
     * @memberof BaseEmployeeDTO
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof BaseEmployeeDTO
     */
    'tenantId': string;
    /**
     * 
     * @type {string}
     * @memberof BaseEmployeeDTO
     */
    'tenantName'?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseEmployeeDTO
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseEmployeeDTO
     */
    'lastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseEmployeeDTO
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseEmployeeDTO
     */
    'phone'?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseEmployeeDTO
     */
    'mail'?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseEmployeeDTO
     */
    'employeeNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseEmployeeDTO
     */
    'birthDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseEmployeeDTO
     */
    'hireDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseEmployeeDTO
     */
    'terminationDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseEmployeeDTO
     */
    'department'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof BaseEmployeeDTO
     */
    'workLocations': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof BaseEmployeeDTO
     */
    'costCenter'?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseEmployeeDTO
     */
    'defaultCouponId'?: string;
    /**
     * 
     * @type {number}
     * @memberof BaseEmployeeDTO
     */
    'receiptCred'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof BaseEmployeeDTO
     */
    'bavNotInterested'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof BaseEmployeeDTO
     */
    'numberOfKids'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof BaseEmployeeDTO
     */
    'isSyncedFromHRSystem'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof BaseEmployeeDTO
     */
    'homeAddressStreet'?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseEmployeeDTO
     */
    'homeAddressStreetLine2'?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseEmployeeDTO
     */
    'homeAddressPostalCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseEmployeeDTO
     */
    'homeAddressCity'?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseEmployeeDTO
     */
    'homeAddressRegion'?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseEmployeeDTO
     */
    'legalTermsLastConsentDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseEmployeeDTO
     */
    'hrSystemBenefitTemplateId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof BaseEmployeeDTO
     */
    'mailDeliveryError'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof BaseEmployeeDTO
     */
    'bikeleasingEmployeeCode'?: string;
}

export const BaseEmployeeDTOSalutationEnum = {
    Mr: 'MR',
    Ms: 'MS',
    Divers: 'DIVERS',
    Company: 'COMPANY'
} as const;

export type BaseEmployeeDTOSalutationEnum = typeof BaseEmployeeDTOSalutationEnum[keyof typeof BaseEmployeeDTOSalutationEnum];
export const BaseEmployeeDTOStatusEnum = {
    Active: 'ACTIVE',
    Inactive: 'INACTIVE',
    Registered: 'REGISTERED',
    Deleted: 'DELETED'
} as const;

export type BaseEmployeeDTOStatusEnum = typeof BaseEmployeeDTOStatusEnum[keyof typeof BaseEmployeeDTOStatusEnum];
export const BaseEmployeeDTORolesEnum = {
    TenantAdmin: 'TENANT_ADMIN',
    TenantAssistant: 'TENANT_ASSISTANT',
    User: 'USER',
    TenantSales: 'TENANT_SALES'
} as const;

export type BaseEmployeeDTORolesEnum = typeof BaseEmployeeDTORolesEnum[keyof typeof BaseEmployeeDTORolesEnum];
export const BaseEmployeeDTOEmployeeTypeEnum = {
    FullTime: 'FULL_TIME',
    PartTime: 'PART_TIME',
    Intern: 'INTERN',
    Student: 'STUDENT',
    MiniJob: 'MINI_JOB',
    Apprenticeship: 'APPRENTICESHIP',
    Training: 'TRAINING',
    External: 'EXTERNAL',
    Misc: 'MISC'
} as const;

export type BaseEmployeeDTOEmployeeTypeEnum = typeof BaseEmployeeDTOEmployeeTypeEnum[keyof typeof BaseEmployeeDTOEmployeeTypeEnum];
export const BaseEmployeeDTOSourceEnum = {
    Probonio: 'Probonio',
    Bikeleasing: 'Bikeleasing',
    Import: 'Import'
} as const;

export type BaseEmployeeDTOSourceEnum = typeof BaseEmployeeDTOSourceEnum[keyof typeof BaseEmployeeDTOSourceEnum];
export const BaseEmployeeDTOCivilStatusEnum = {
    Single: 'SINGLE',
    Married: 'MARRIED',
    Divorced: 'DIVORCED',
    Widowed: 'WIDOWED',
    CivilUnion: 'CIVIL_UNION',
    CivilUnionDeceased: 'CIVIL_UNION_DECEASED',
    CivilUnionCancelled: 'CIVIL_UNION_CANCELLED'
} as const;

export type BaseEmployeeDTOCivilStatusEnum = typeof BaseEmployeeDTOCivilStatusEnum[keyof typeof BaseEmployeeDTOCivilStatusEnum];
export const BaseEmployeeDTOLegalTermsActionEnum = {
    None: 'NONE',
    Skip: 'SKIP',
    Consent: 'CONSENT'
} as const;

export type BaseEmployeeDTOLegalTermsActionEnum = typeof BaseEmployeeDTOLegalTermsActionEnum[keyof typeof BaseEmployeeDTOLegalTermsActionEnum];
export const BaseEmployeeDTORequiredActionsEnum = {
    UpdateProfile: 'UpdateProfile'
} as const;

export type BaseEmployeeDTORequiredActionsEnum = typeof BaseEmployeeDTORequiredActionsEnum[keyof typeof BaseEmployeeDTORequiredActionsEnum];
export const BaseEmployeeDTOPreferredPortalEnum = {
    Bikeleasing: 'BIKELEASING',
    OnePortal: 'ONE_PORTAL',
    Neutral: 'NEUTRAL'
} as const;

export type BaseEmployeeDTOPreferredPortalEnum = typeof BaseEmployeeDTOPreferredPortalEnum[keyof typeof BaseEmployeeDTOPreferredPortalEnum];


